import { jsx } from "react/jsx-runtime";
const Email = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 6.98V17a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6.981A3 3 0 0 0 19 4H5a3 3 0 0 0-3 2.98Zm2.112-.44A1 1 0 0 1 5 6h14a1 1 0 0 1 .888.54L12 11.798 4.112 6.54ZM20 8.869V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8.869l7.445 4.963a1 1 0 0 0 1.11 0L20 8.87Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const Email_Email = Email;
export default Email_Email;
